import { config } from 'config';
import { sendMultiPartRequest, sendRequest } from 'services/base/sendRequest';
import { parseFetchError } from 'utils/http';
import { appConfig } from '../../config/app';

const storeDocument = data => {
  const serviceUrl =
    config.serverURL +
    appConfig.api_routes.prefix +
    appConfig.api_routes.modules.documents.prefix +
    appConfig.api_routes.modules.documents.services.documentStore;

  let formData = new FormData();

  formData.append('area', JSON.stringify(data.area));
  formData.append('stage', JSON.stringify(data.stage));
  formData.append('documentType', JSON.stringify(data.documentType));
  formData.append('description', data.description);
  formData.append('link', data.link);

  formData.append('stageId', data.stageId);
  formData.append('userId', data.userId);
  formData.append('personId', data.personId);
  formData.append('fileContent', data.fileContent);
  data.annexes.forEach(file => {
    formData.append('annexes', file);
  });

  data.attachments.forEach(file => {
    formData.append('attachments', file);
  });

  return sendMultiPartRequest(serviceUrl, formData);
};

const personDocuments = documentNumber => {
  const serviceUrl =
    config.serverURL +
    appConfig.api_routes.prefix +
    appConfig.api_routes.modules.documents.prefix +
    appConfig.api_routes.modules.documents.services.personDocuments;

  return sendRequest(serviceUrl, { documentNumber }, true);
};

const stageDocuments = (stage, stageId, personId) => {
  const serviceUrl =
    config.serverURL +
    appConfig.api_routes.prefix +
    appConfig.api_routes.modules.documents.prefix +
    appConfig.api_routes.modules.documents.services.stageDocuments;

  return sendRequest(serviceUrl, { stage, stageId, personId }, true);
};

const legalProcessActionDocuments = (actionId, personId) => {
  const serviceUrl =
    config.serverURL +
    appConfig.api_routes.prefix +
    appConfig.api_routes.modules.documents.prefix +
    appConfig.api_routes.modules.documents.services.legalProcessActionDocuments;

  return sendRequest(serviceUrl, { actionId, personId }, true);
};

const documentView = documentId => {
  const serviceUrl =
    config.serverURL +
    appConfig.api_routes.prefix +
    appConfig.api_routes.modules.documents.prefix +
    appConfig.api_routes.modules.documents.services.documentView;

  return sendRequest(serviceUrl, { documentId }, true);
};

const documentDelete = documentId => {
  const serviceUrl =
    config.serverURL +
    appConfig.api_routes.prefix +
    appConfig.api_routes.modules.documents.prefix +
    appConfig.api_routes.modules.documents.services.documentDelete;

  return sendRequest(serviceUrl, { documentId }, true);
};

const personInfo = personId => {
  const serviceUrl =
    config.serverURL +
    appConfig.api_routes.prefix +
    appConfig.api_routes.modules.documents.prefix +
    appConfig.api_routes.modules.documents.services.personInfo;

  return sendRequest(serviceUrl, { personId }, true);
};

const getActionType = actionTypeId => {
  const serviceUrl =
    config.serverURL +
    appConfig.api_routes.prefix +
    appConfig.api_routes.modules.documents.prefix +
    appConfig.api_routes.modules.documents.services.getActionType;

  return sendRequest(serviceUrl, { actionTypeId }, true);
};

const getDocumentTypes = () => {
  const serviceUrl =
    config.serverURL +
    appConfig.api_routes.prefix +
    appConfig.api_routes.modules.documents.prefix +
    appConfig.api_routes.modules.documents.services.getDocumentTypes;

  return sendRequest(serviceUrl, {}, true);
};

const userSessionExtention = (u, si) => {
  return new Promise(async (resolve, reject) => {
    try {
      const serviceUrl =
        config.serverURL +
        appConfig.api_routes.prefix +
        appConfig.api_routes.modules.documents.prefix +
        appConfig.api_routes.modules.documents.services.userSessionExtention;

      const res = await fetch(serviceUrl, {
        headers: {
          'Access-Control-Allow-Origin': config.serverDomain,
          'Access-Control-Allow-Headers':
            'Origin, X-Requested-With, Content-Type, Accept',
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        credentials: 'include',
        method: 'POST',
        body: JSON.stringify({ u, si }),
      }).catch(err => {
        reject({ respCode: -1, detailedMessage: err.stack });
      });

      const dataOut = await res.json();

      if (dataOut.respCode === 0) {
        localStorage.setItem(config.jwtTokenStoreName, dataOut.data.token);
        localStorage.setItem(
          config.localUserDTO,
          JSON.stringify(dataOut.data.user),
        );
        resolve(dataOut);
      } else {
        localStorage.removeItem(config.jwtTokenStoreName);
        localStorage.removeItem(config.localUserDTO);
        console.log(config.redirectUrlForUnAuthorizedUsers);
        document.location.href = config.redirectUrlForUnAuthorizedUsers;
        reject(dataOut);
      }
    } catch (e) {
      reject({
        respCode: -1,
        message: parseFetchError(e),
      });
    }
  });
};

export {
  storeDocument,
  personDocuments,
  stageDocuments,
  legalProcessActionDocuments,
  documentView,
  documentDelete,
  personInfo,
  getActionType,
  getDocumentTypes,
  userSessionExtention,
};
